export default __webpack_public_path__ + "static/media/not-points.8191c129.svg";